import React from "react";
import {
  SELECT_JOB_CONFGURATION,
  UPDATE_JOB,
  DELETE_JOB,
  GET_SELECT_GRID_COLUMN_XML,
  INSERT_JOB,
  SELECT_JOB_POSTION_PARAM,
  SELECT_JOB_POSTION_STAGEHOOK_PARAM,
  INSERT_JOB_QUEUE,
  ADD_JOB_SCHEDULER,
} from "../../api-setup/api-endpoints";
import { getUserCredential, getTenantCookieData } from "../../lib/cookies";
import { POSTAPI, errStatusHandler, generateHeader } from "../../api-setup/api-helper";
import { GridColumnDataMapper } from "../../utils/utils";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { setNewMessage } from "../../redux/actions/setting-actions";
import { DEFAULT_SORT } from "../../constants/grid";
import { POSTION_PARMAS } from "../../constants/constants";
import { GetCompPlanDataApi, GeJobTypeAPI, GetStagehookTypesData } from "../../lib/common-service";

export default function Plan() {
  /**
   * start to define default states for common grid functions (list/insert/update/delete)
   */
  const cookiesData = getUserCredential();
  const header = {
    "x-access-token": cookiesData.secretToken,
  };
  const history = useHistory();
  const dispatch = useDispatch();
  const [data, setData] = React.useState([]);
  const [columns, setColumns] = React.useState([]);
  const [dataCount, setDataCount] = React.useState(0);
  const [loadingState, setLoadState] = React.useState({
    isSaveData: undefined,
    isDeleteData: undefined,
  });
  const [visible, setVisible] = React.useState(false);

  const [initialLoading, setLoadingState] = React.useState(false);
  const [editData, setEditData] = React.useState("");
  const [confirmationPopup, setConfirmationPopup] = React.useState({
    title: "Delete",
    desc: "Are you sure you want to delete this record?",
    isVisible: false,
    type: "",
    actionBtn: [],
    data: {},
    action: "Delete",
  });
  const [originalData, setOriginalData] = React.useState([]);
  const [isAPICalling, setAPICallingState] = React.useState(false);
  const [isRefreshLoading, setRefreshLoading] = React.useState(false);
  const defaultPageSize = getTenantCookieData("record_per_page");

  const [initialPostionLoading, setPostionLoadingState] = React.useState(false);
  const [isPostionAPICalling, setPostionAPICallingState] = React.useState(false);
  const [postioncolumns, setPostioncolumns] = React.useState([]);
  const [postionData, setPostionData] = React.useState([]);
  const [originalPostionData, setOriginalPostionData] = React.useState([]);
  const [isCompPlanDisable, setIsCompPlanDisable] = React.useState(false);
  const [postionCount, setPostionCount] = React.useState(0);
  const [loading, setLoadingStateSearch] = React.useState({
    isSearchLoader: false,
    updateColumn: false,
  });
  const [originalColumns, setOriginalColumns] = React.useState([]);

  /**
   * end to define default states for common grid functions (list/insert/update/delete)
   */

  /**
   * start to define default states for periods and period types
   */
  const [jobTypeFields, setJobTypeFields] = React.useState({
    jobTypeValue: {
      in_job_mstr_key: "",
    },
    jobTypeData: [],
    isJobTypeDataLoading: true,
  });
  const [originJobType, setoriginJobType] = React.useState([]);
  const [compPlanFields, setcompPlanFields] = React.useState({
    compPlanValue: {
      in_comp_plan_mstr_key: "",
    },
    compPlanData: [],
    iscompPlanDataLoading: true,
  });
  const [originCompPlan, setOriginCompPlan] = React.useState([]);
  const [stagehookFields, setStagehookFields] = React.useState({
    stagehookValue: {
      in_stagehook_mstr_key: "",
    },
    stagehookData: [],
    isstagehookDataLoading: true,
  });
  const [originStageHook, setOriginStagehook] = React.useState([]);
  const [recurringTypeFields, setRecurringTypeFields] = React.useState({
    recurringTypeValue: {
      in_recurring_key: "",
    },
    recurringTypeData: [],
    isRecurringTypeDataLoading: true,
  });
  const [originRecurringType, setoriginRecurringType] = React.useState([]);

  const getListDataAsync = (listData) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, SELECT_JOB_CONFGURATION, null, header, listData, dispatch).then((res) => {
        if (res) {
          const reqData = {
            in_tenant_id: cookiesData.out_tenant_id,
            in_filter: null,
            in_filter_db_name: "procare_system",
            in_filter_table_name: "vw_job_master",
            in_result_name_mstr_key: 0,
            in_event_type_mstr_key: 0,
            in_hide_column: 0,
          };
          let userData = [];
          userData = JSON.parse(JSON.stringify(res.data.row_result));

          if (listData.in_load_type == "grid-reload") {
            setTimeout(function () {
              getColumListXML(reqData, userData);
            }, 100);
          }
          if (res.data.out_parameters.out_ret_code > 0) {
            setLoadingState(true);
            errStatusHandler(res, history, dispatch);
          }

          userData.map((item, idx) => {
            item.rowId = idx;
            item.selected = false;
            // Check each key in POSTION_PARMAS
            for (const key in POSTION_PARMAS) {
              if (POSTION_PARMAS.hasOwnProperty(key)) {
                // Check if the key exists in the userData item and its value is 1
                if (item[key] === 1) {
                  if (!item.job_param) {
                    item.job_param = POSTION_PARMAS[key]; // Set the corresponding key from POSTION_PARMAS
                  } else {
                    item.job_param += `,${POSTION_PARMAS[key]}`; // Append with a comma separator
                  }
                }
              }
            }
            return 0;
          });
          setAPICallingState(false);
          setLoadingState(true);
          setEditData("");
          setConfirmationPopup({
            ...confirmationPopup,
            isVisible: false,
            type: "",
            actionBtn: [],
            data: {},
            action: "",
          });
          setData(userData);
          setOriginalData(userData);
          setDataCount(res.data.out_parameters.out_total_rows);
          setRefreshLoading(false);
          setLoadingStateSearch({
            ...loading,
            isSearchLoader: false,
          });
          resolve(userData);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const getAllListData = async (reqData) => {
    try {
      const res = await POSTAPI(false, SELECT_JOB_CONFGURATION, null, header, reqData, dispatch);
      if (res.data.out_parameters.out_ret_code > 0) {
        return null;
      } else {
        return JSON.parse(JSON.stringify(res.data.row_result));
      }
    } catch (error) {
      return null;
    }
  };

  function findSpecificObjects(array, jobTypeKey, compPlanKey) {
    if (array == null) return [];
    return array.filter(
      (obj) =>
        String(obj.job_type_mstr_key) === String(jobTypeKey) && String(obj.comp_plan_keys) === String(compPlanKey)
    );
  }

  const addDataAsync = async (bodyData) => {
    const apiCallData = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_db_role_key: cookiesData?.out_db_role_key,
      in_filter: null,
      in_sort_number: DEFAULT_SORT.number,
      in_sort_order: DEFAULT_SORT.order,
      in_page_row_offset: 0,
      in_page_rows: defaultPageSize.recordTake,
      in_load_type: "data-reload",
    };

    const dataLength = await getAllListData(apiCallData);

    const foundObjects = findSpecificObjects(dataLength, 2, bodyData.in_comp_plan_mstr_key);
    let updatedData = { ...bodyData };
    if (jobTypeFields.jobTypeValue.code === "comp_plan") {
      updatedData.report_publish_extis = foundObjects.length === 0;
    }

    setLoadState({ ...loadingState, isSaveData: false });

    POSTAPI(false, INSERT_JOB, null, header, updatedData, dispatch).then((res) => {
      setRefreshLoading(false);
      if (res.status) {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        } else {
          setLoadState({ ...loadingState, isSaveData: true });
        }
      }
    });
  };

  const getListDataLengthAsync = (listData) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, SELECT_JOB_CONFGURATION, null, header, listData, dispatch).then((res) => {
        if (res) {
          let userData = [];
          userData = JSON.parse(JSON.stringify(res.data.row_result));
          resolve(userData);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const deleteDataAsync = async (bodyData) => {
    setRefreshLoading(true);
    return new Promise(function (resolve) {
      POSTAPI(false, DELETE_JOB, null, header, bodyData, dispatch).then((res) => {
        const totaljobTypes = bodyData.in_job_mstr_key.length;
        const unSucessFullCount = res.data.successCount;
        setRefreshLoading(false);
        if (res.data.out_parameters.out_ret_code > 0) {
          let msg = res.data.out_parameters.out_error_msg;

          if (totaljobTypes !== unSucessFullCount) {
            msg =
              unSucessFullCount +
              " Job (" +
              res.data.successName +
              ") out of " +
              totaljobTypes +
              " " +
              "exists in job master - cannot delete.";

            setLoadState({ ...loadingState, isDeleteData: true });

            setTimeout(function () {
              resolve("success");
            });
          } else {
            if (res.data.out_parameters.out_ret_code === 3) {
              msg =
                "Unable to delete. It appears that the comp plan job exists associated with the selected report publish.";
            }
            setLoadState({ ...loadingState, isDeleteData: true });
            setTimeout(function () {
              resolve("error");
            });
          }
          setConfirmationPopup({
            ...confirmationPopup,
            isVisible: false,
            type: "",
            actionBtn: [],
            data: {},
            action: "",
          });
          dispatch(
            setNewMessage({
              message: msg,
              type: "Error",
              show: true,
            })
          );
        } else {
          setLoadState({ ...loadingState, isDeleteData: true });

          setConfirmationPopup({
            ...confirmationPopup,
            isVisible: false,
            type: "",
            actionBtn: [],
            data: {},
            action: "",
          });
          setTimeout(function () {
            resolve("success");
          });
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const exportDataAsync = (bodyData) => {
    setRefreshLoading(true);
    return new Promise(function (resolve, reject) {
      POSTAPI(false, SELECT_JOB_CONFGURATION, null, generateHeader(), bodyData, dispatch).then((res) => {
        setRefreshLoading(false);
        if (res && (res.data.out_parameters.out_ret_code === 0 || res.data.out_parameters.out_ret_code === 2)) {
          resolve(res.data.row_result);
        } else {
          dispatch(
            setNewMessage({
              message: res?.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          resolve([]);
          errStatusHandler(res, history, dispatch);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const updateDataAsync = (bodyData) => {
    setRefreshLoading(true);
    return new Promise(function (resolve, reject) {
      POSTAPI(false, UPDATE_JOB, null, generateHeader(), bodyData, dispatch).then((res) => {
        setRefreshLoading(false);
        if (res && res.data.out_parameters.out_ret_code === 0) {
          resolve(true);
        } else {
          dispatch(
            setNewMessage({
              message: res?.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          resolve([]);
          errStatusHandler(res, history, dispatch);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const getPostionListDataAsync = (listData) => {
    let endpoint = SELECT_JOB_POSTION_PARAM;
    if (listData.job_type_code === "email_process") {
      endpoint = SELECT_JOB_POSTION_STAGEHOOK_PARAM;
    }
    return new Promise(function (resolve, reject) {
      POSTAPI(false, endpoint, null, header, listData, dispatch).then((res) => {
        if (res) {
          const reqData = {
            in_tenant_id: cookiesData.out_tenant_id,
            in_filter: null,
            in_filter_db_name: "procare_system",
            in_filter_table_name: "vw_position_param",
            in_result_name_mstr_key: 0,
            in_event_type_mstr_key: 0,
            in_hide_column: 0,
          };

          setTimeout(function () {
            getColumListXML(reqData);
          }, 100);

          if (res.data.out_parameters.out_ret_code > 0) {
            setPostionLoadingState(true);
            errStatusHandler(res, history, dispatch);
          }
          let userData = [];
          userData = JSON.parse(JSON.stringify(res.data.row_result));

          setPostionAPICallingState(false);
          setPostionLoadingState(true);
          setEditData("");
          setConfirmationPopup({
            ...confirmationPopup,
            isVisible: false,
            type: "",
            actionBtn: [],
            data: {},
            action: "",
          });

          setPostionData(userData);
          //   const columData = GridColumnDataMapper(
          //     res.data.out_parameters.out_column_xml
          // );
          //   setPostioncolumns(columData)
          setOriginalPostionData(userData);
          const hasIsParamAssignOne = userData.some((item) => item.is_param_assign === 1);
          if (hasIsParamAssignOne) {
            setIsCompPlanDisable(true);
          } else {
            setIsCompPlanDisable(false);
          }
          setPostionCount(res.data.out_parameters.out_total_rows);
          setRefreshLoading(false);

          resolve(userData);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const getColumListXML = (reqData) => {
    POSTAPI(false, GET_SELECT_GRID_COLUMN_XML, null, header, reqData, dispatch).then((res) => {
      if (res.data.out_parameters.out_ret_code > 0) {
        dispatch(
          setNewMessage({
            message: res.data.out_parameters.out_error_msg,
            type: "Error",
            show: true,
          })
        );
        setAPICallingState(true);
        errStatusHandler(res, history, dispatch);
      } else {
        const columData = GridColumnDataMapper(res.data.out_parameters.out_columns_xml);
        if (reqData.in_filter_table_name === "vw_job_master") {
          const ACTION_COLUM_OBJECT = {
            field: "job_mstr_key",
            alias: "a",
            title: "ACTION",
            type: "string",
            show: true,
            width: "10px",
          };
          columData.unshift(ACTION_COLUM_OBJECT);
          columData.map((cItem) => {
            cItem.minWidth = cItem.field === "job_mstr_key" ? 50 : 180;
            return 0;
          });
          setOriginalColumns(columData);
          setColumns(columData);
          setVisible(true);
        } else {
          columData.map((cItem) => {
            cItem.minWidth = cItem.field === "is_param_assign" ? 90 : 180;
            return 0;
          });
          setPostioncolumns(columData);
        }
      }
    });
  };

  const getJobTypesData = async () => {
    setoriginJobType([]);
    setJobTypeFields({
      ...jobTypeFields,
      isJobTypeDataLoading: true,
    });
    let jobTypeData = {
      in_filter: null,
      in_sort_number: DEFAULT_SORT.number,
      in_sort_order: "ASC",
    };

    let res = await GeJobTypeAPI(jobTypeData, dispatch, history);

    if (res.length > 0) {
      let tempArray = [];

      res.map((item) => {
        if (item && item.job_type_code !== "report_publish") {
          let obj = {};
          obj.text = item.job_type_name;
          obj.id = item.job_type_mstr_key;
          obj.code = item.job_type_code;

          tempArray.push(obj);
        }
        return 0;
      });
      setoriginJobType(tempArray);
      setJobTypeFields({
        ...jobTypeFields,
        jobTypeData: tempArray,
        jobTypeValue: tempArray[0],
        isJobTypeDataLoading: false,
      });
    } else {
      setJobTypeFields({
        ...jobTypeFields,
        isJobTypeDataLoading: false,
      });
    }
  };
  const getCompPlanData = async () => {
    let dataObj = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: null,
      in_sort_number: null,
      in_sort_order: null,
      in_user_key: cookiesData.out_user_id,
      in_multi_sort_order: null,
    };
    let res = await GetCompPlanDataApi(dataObj, dispatch, history);

    if (res.length > 0) {
      let tempArray = [];

      res.map((item) => {
        let obj = {};
        obj.text = item.comp_plan_name;
        obj.id = item.comp_plan_mstr_key;

        tempArray.push(obj);
        return 0;
      });

      setOriginCompPlan(tempArray);
      setcompPlanFields({
        ...compPlanFields,
        compPlanData: tempArray,
        compPlanValue: tempArray[0],
        iscompPlanDataLoading: false,
      });
    } else {
      setcompPlanFields({
        ...compPlanFields,
        iscompPlanDataLoading: false,
      });
    }
  };
  const getStagehookTypesData = async () => {
    const listData = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_db_role_key: cookiesData?.out_db_role_key,
      in_filter: "AND a.job_type_mstr_key=3",
      in_sort_number: DEFAULT_SORT.number,
      in_sort_order: DEFAULT_SORT.order,
      in_page_row_offset: 0,
      in_page_rows: defaultPageSize.recordTake,
    };
    let res = await GetStagehookTypesData(listData, dispatch, history);

    if (res.length > 0) {
      let tempArray = [];

      res.map((item) => {
        let obj = {};
        obj.text = item.job_name;
        obj.id = item.job_mstr_key;
        tempArray.push(obj);
        return 0;
      });

      setOriginStagehook(tempArray);
      setStagehookFields({
        ...stagehookFields,
        stagehookData: tempArray,
        stagehookValue: tempArray[0],
        isstagehookDataLoading: false,
      });
    } else {
      setOriginStagehook([]);
      setStagehookFields({
        ...stagehookFields,
        stagehookData: [],
        isstagehookDataLoading: false,
      });
    }
  };

  const addJobQueueDataAsync = (bodyData, insertRecurringJobData) => {
    // setRefreshLoading(true);
    // setLoadState({ ...loadingState, isSaveData: false });

    POSTAPI(false, INSERT_JOB_QUEUE, null, header, bodyData, dispatch).then((res) => {
      if (res.status) {
        setRefreshLoading(false);
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        } else {
          addJobRecurringJobdataDataAsync(insertRecurringJobData);
          // setLoadState({ ...loadingState, isSaveData: true });
        }
      }
    });
  };

  const addJobRecurringJobdataDataAsync = (bodyData) => {
    setRefreshLoading(true);
    setLoadState({ ...loadingState, isSaveData: false });

    POSTAPI(false, ADD_JOB_SCHEDULER, null, header, bodyData, dispatch).then((res) => {
      if (res.status) {
        setRefreshLoading(false);
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        } else {
          setLoadState({ ...loadingState, isSaveData: true });
        }
      }
    });
  };

  return [
    {
      data,
      columns,
      dataCount,
      setData,
      editData,
      originalData,
      isAPICalling,
      setEditData,
      confirmationPopup,
      setConfirmationPopup,
      initialLoading,
      setAPICallingState,
      loadingState,
      setLoadState,
      setOriginalData,
      setRefreshLoading,
      isRefreshLoading,
      originJobType,
      jobTypeFields,
      setJobTypeFields,
      stagehookFields,
      setStagehookFields,
      originStageHook,
      setOriginalPostionData,
      setPostioncolumns,
      postioncolumns,
      postionData,
      setPostionData,
      postionCount,
      isPostionAPICalling,
      setPostionAPICallingState,
      initialPostionLoading,
      originCompPlan,
      compPlanFields,
      setcompPlanFields,
      setIsCompPlanDisable,
      isCompPlanDisable,
      recurringTypeFields,
      setRecurringTypeFields,
      originRecurringType,
      setoriginRecurringType,
      setLoadingStateSearch,
      loading,
      setColumns,
      originalPostionData,
      visible,
      originalColumns,
    },
    {
      getListDataAsync,
      addDataAsync,
      deleteDataAsync,
      updateDataAsync,
      getJobTypesData,
      exportDataAsync,
      getCompPlanData,
      getStagehookTypesData,
      getPostionListDataAsync,
      addJobQueueDataAsync,
      addJobRecurringJobdataDataAsync,
      getListDataLengthAsync,
      getAllListData,
    },
  ];
}
